import { Button, Container, Grid, Paper, TextField, Typography } from "@mui/material"
import React, { useState } from "react"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import { Link, useNavigate } from "react-router-dom"
import apiClient from "../api/apiClient"

import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { showModal } from "../redux/modalSlice"
import { isTrackingNumberRequired, trackingNumberSchema } from "../modules/registrationTracking"
import * as Yup from "yup"

function AddnewClient() {
  const navigate = useNavigate()
  const initilaState = {
    fname: "",
    lname: "",
    address: "",
    state: "",
    zip: "",
    country: "",
    phone_no: "",
    email: "",
    barcode: "",
    tracking_no: "",
    pet: ""
  }
  const dispatch = useDispatch()
  const [client, setClient] = useState(initilaState)
  const [message, setmessage] = useState({ text: "", color: "" })
  const handelchange = (key, value) => {
    setClient({ ...client, [key]: value })
  }
  const handelsubmit = async e => {
    e.preventDefault()
    const data = { ...client, country: client.country.trim(), barcode: client.barcode.trim().toLowerCase(), tracking_no: client.tracking_no.trim() }
    try {
      Yup.object({ country: Yup.string().trim().required(), tracking_no: trackingNumberSchema }).validateSync(data)
    } catch (error) {
      setmessage({ text: error.message, color: "red" })
      return
    }
    const result = await apiClient.post("/client/", data)
    //console.log(result);
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    navigate("/admin/client")
  }
  function resetErrors() {
    setmessage({ text: "", color: "" })
  }

  return (
    <div>
      <Container className="" maxWidth="lg">
        <Grid container className="d-flex justify-content-center " spacing={2}>
          <Grid item md={10} sx={{ backgroundColor: "" }} xs={12}>
            <div className="d-flex align-items-center">
              <div className="p-2 rounded-pill " style={{ backgroundColor: "#e8d9d5" }}>
                <Link to={"/admin/client"}>
                  <ArrowBackIosIcon />
                </Link>
              </div>
              <h4 className="ps-1 mb-0 fw-bold">Add New Clients:</h4>
            </div>
          </Grid>
        </Grid>
        <Grid
          md={10}
          xs={12}
          spacing={2}
          component={Paper}
          elevation={5}
          sx={{ marginTop: 5, padding: 5 }}
        >
          <form onSubmit={handelsubmit}>
            <Grid md={10} xs={12}>
              <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    value={client.fname}
                    onChange={e => handelchange("fname", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Last Name"
                    variant="outlined"
                    value={client.lname}
                    onChange={e => handelchange("lname", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    value={client.email}
                    onChange={e => handelchange("email", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Contact"
                    variant="outlined"
                    value={client.phone_no}
                    onChange={e => handelchange("phone_no", e.target.value)}
                  />
                </Grid>
              </Grid>

              <Typography sx={{ py: 2 }} variant="h6" color="initial">
                Location
              </Typography>
              <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Address"
                    variant="outlined"
                    value={client.address}
                    onChange={e => handelchange("address", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Country"
                    variant="outlined"
                    value={client.country}
                    onChange={e => handelchange("country", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="State"
                    variant="outlined"
                    value={client.state}
                    onChange={e => handelchange("state", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Zip"
                    variant="outlined"
                    value={client.zip}
                    onChange={e => handelchange("zip", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Barcode"
                    variant="outlined"
                    value={client.barcode}
                    onChange={e => handelchange("barcode", e.target.value)}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    required={isTrackingNumberRequired(client.country, client.barcode)}
                    label="Tracking Number"
                    helperText="Required for U.S. REG and EXP tests"
                    value={client.tracking_no}
                    onChange={e => handelchange("tracking_no", e.target.value)}
                    inputProps={{ maxLength: 120 }}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="pet"
                    variant="outlined"
                    value={client.pet}
                    onChange={e => handelchange("pet", e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={{ py: 2 }}>
              {message.text && <p role="alert" style={{ color: message.color }}>{message.text}</p>}
              <Button className="btn_bg_secondery " type="submit" variant="contained">
                Save & Assign Barcodes
              </Button>
            </Grid>
          </form>
        </Grid>
      </Container>
    </div>
  )
}
export default AddnewClient
